var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHyperlinkWithGreenBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2530_870)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9143,
    cy: 19.3286,
    rx: 19.9143,
    ry: 19.3286,
    fill: "#367B6E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1405 27.3795C18.3151 29.2049 15.5233 29.3817 13.9154 27.7738C12.3075 26.1659 12.4843 23.3741 14.3097 21.5488L19.0378 16.8207C20.8632 14.9953 23.655 14.8185 25.2629 16.4264C25.319 16.4807 25.3622 16.5471 25.39 16.6216C25.4179 16.6962 25.4298 16.7775 25.4251 16.8608C25.4204 16.9441 25.3992 17.0277 25.3627 17.1068C25.3262 17.1859 25.2751 17.2589 25.2125 17.3216C25.1498 17.3843 25.0768 17.4353 24.9977 17.4718C24.9186 17.5083 24.835 17.5295 24.7517 17.5342C24.6684 17.5389 24.5871 17.527 24.5125 17.4991C24.4379 17.4713 24.3716 17.4281 24.3173 17.372C23.1564 16.2111 21.1886 16.3358 19.8708 17.6536L15.1427 22.3817C13.8248 23.6996 13.7002 25.6673 14.861 26.8282C16.0219 27.9891 17.9897 27.8644 19.3075 26.5466L24.0356 21.8185C24.0975 21.755 24.1699 21.703 24.2486 21.6655C24.3273 21.6279 24.4108 21.6055 24.4942 21.5997C24.5775 21.5938 24.6592 21.6046 24.7343 21.6313C24.8094 21.658 24.8765 21.7002 24.9317 21.7554C24.9868 21.8106 25.029 21.8777 25.0558 21.9528C25.0825 22.0279 25.0933 22.1095 25.0874 22.1929C25.0815 22.2762 25.0592 22.3597 25.0216 22.4384C24.984 22.5172 24.932 22.5896 24.8686 22.6514L20.1405 27.3795ZM28.6511 18.869C26.8257 20.6943 24.0339 20.8712 22.426 19.2632C22.3699 19.2089 22.3267 19.1426 22.2989 19.068C22.271 18.9934 22.2591 18.9121 22.2638 18.8288C22.2685 18.7455 22.2897 18.6619 22.3262 18.5828C22.3627 18.5037 22.4138 18.4307 22.4764 18.368C22.5391 18.3054 22.6121 18.2543 22.6912 18.2178C22.7703 18.1813 22.8539 18.1601 22.9372 18.1554C23.0205 18.1507 23.1018 18.1626 23.1764 18.1905C23.251 18.2183 23.3173 18.2615 23.3716 18.3176C24.5325 19.4785 26.5002 19.3538 27.8181 18.036L32.5462 13.3079C33.8641 11.99 33.9887 10.0223 32.8278 8.86141C31.667 7.70055 29.6992 7.82518 28.3814 9.14304L23.6533 13.8711C23.5914 13.9346 23.519 13.9866 23.4403 14.0242C23.3616 14.0617 23.2781 14.0841 23.1947 14.0899C23.1113 14.0958 23.0297 14.0851 22.9546 14.0583C22.8795 14.0316 22.8124 13.9894 22.7572 13.9342C22.702 13.879 22.6599 13.8119 22.6331 13.7368C22.6064 13.6617 22.5956 13.5801 22.6015 13.4967C22.6074 13.4134 22.6297 13.3299 22.6673 13.2512C22.7049 13.1725 22.7569 13.1001 22.8203 13.0382L27.5484 8.31008C29.3738 6.4847 32.1655 6.30787 33.7735 7.91579C35.3814 9.52371 35.2046 12.3155 33.3792 14.1408L28.6511 18.869Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2530_870",
    x: 0,
    y: 0,
    width: 47.8286,
    height: 46.6571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2530_870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2530_870",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHyperlinkWithGreenBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hyperlinkWithGreenBackground.249d8a822bb5c1f0286049a6d7875ece.svg";